<template>
  <div>
    <div v-if="!replacementItemEnabled">
      Verify Replacement Receipt Quantities is not required for this
      transaction... Please Continue...
    </div>
    <div  v-else>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="verfify_tooltip_name" :name="verfify_tooltip_name" :description="verify_tooltip_description" :editable="editable"></tool-tip>

      <div class="row">
        <div class="col-sm-12">
          <el-table
            :data="replacementItems"
            :summary-method="summary"
            show-summary
            :default-sort="{ prop: 'itemNumber', order: 'ascending' }"
          >
            <el-table-column
              :min-width="100"
              prop="itemNumber"
              label="Item No"
            />
            <el-table-column
              :min-width="150"
              prop="fundCitationName"
              label="Fund Citation"
            />
            <el-table-column
              :min-width="150"
              prop="stockClassName"
              label="Class of Supply"
            />
            <el-table-column
              :min-width="150"
              prop="stockSubClassName"
              label="Sub Class"
            />
            <el-table-column
              :min-width="200"
              prop="stockDescription"
              label="Stock No & Description"
            />
            <el-table-column
              :min-width="150"
              prop="unitMeasure"
              label="Unit of Measure"
            />
            <el-table-column
              :min-width="210"
              prop="requestedQuantity"
              label="Request Qty"
              :formatter="formatReceivedQuantity"
            />
            <el-table-column
              min-width="210"
              prop="receivedQuantity"
              label="Received Qty"
            >
              <editable-cell
                :show-input="editMode"
                slot-scope="{ row }"
                v-model="row.receivedQuantity"
                type="number"
                v-on:input="markChanged(row.lineItemId)"
              >
                <span slot="content">{{
                  row.receivedQuantity != null
                    ? formatNumber(row.receivedQuantity)
                    : ""
                }}</span>
              </editable-cell>
            </el-table-column>
            <el-table-column
              :min-width="210"
              prop="unitPrice"
              label="Unit Price"
              :formatter="formatMoney"
            />
            <el-table-column
              :min-width="210"
              prop="partnerItemTotal"
              label="Partner Total"
              :formatter="formatMoney"
            />
            <el-table-column
              :min-width="210"
              prop="usItemTotal"
              label="US Total($)"
              :formatter="formatMoney"
            />
            <el-table-column
              :min-width="210"
              prop="usItemBalance"
              label="US Balance Due($)"
              :formatter="formatMoney"
            />
          </el-table>
          <div
            style="margin-top: 20px; float: right;"
            v-if="!isReadOnly && !isPartnerAccount && !isReturned"
          >
            <base-button
              :disabled="isReadOnly"
              v-show="editMode"
              type="danger"
              class="alert_footer_button mr-4 btn_extra_small btn_info"
              @click.native="cancelEditMode"
            >
              Cancel
            </base-button>
            <base-button
              :disabled="isReadOnly"
              type="primary"
              class="alert_footer_button btn_extra_small btn_info"
              @click.native="handleEdit()"
            >
              {{ editMode ? "Save" : "Edit" }}
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn } from "element-ui";
import { BaseSwitch, BaseButton, EditableCell } from "@/components";
import { ReplacementReceiptModal } from './ReplacementReceiptModal.vue';
import Util from "../../../../../util/util";
import  toolTip  from "../../../Tooltip";


export default {
  name: "replacement-receipt",
  props: ["isReadOnly"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseButton,
    EditableCell,
    ReplacementReceiptModal,
    toolTip
  },
  async mounted() {
   await this.getAllTooltips()
   this.loadToolTips()
 },
  data() {
    return {
      editMode: false,
      editing: null,
      changedItems: [],
      verify_tooltip_description: '',
      verfify_tooltip_name: ''
    };
  },
  computed: {
    ...mapGetters({
      replacementItems: "replacementItemReceipt/replacementItems",
      replacementItemEnabled: "replacementItemReceipt/replacementItemEnabled",
       orderMetadata: "orderMetadata/orderMetadata",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    isReturned() {
      if (this.orderMetadata) {
        return [
          Util.ORDER_STATUS_INVOICED,
          Util.ORDER_STATUS_RETURNED,
          Util.ORDER_STATUS_BILLED,
          Util.ORDER_STATUS_COMPLETED,
        ].includes(`${this.orderMetadata.orderStatus}`);
      }
    },
  },
  methods: {
    ...mapActions({
      getReplacementItems: "replacementItemReceipt/getReplacementItems",
      getReplacementItemEnabled: "replacementItemReceipt/getReplacementItemEnabled",
      saveReplacementItems:"replacementItemReceipt/saveReplacementItems",
      getReplacementItemReceiptStatus:"replacementItemReceipt/getReplacementItemReceiptStatus",
      getAllTooltips: "tooltip/getToolTips"
      
    }),
    loaded() {
      let ctx = this;
      ctx.getReplacementItemEnabled(ctx.$route.params.id).then(() => {
        if (ctx.replacementItemEnabled) {
          ctx.getReplacementItems(ctx.$route.params.id).then(() => {});
        }
      });
    },
    loadToolTips(){
    const verifyToolTip = this.toolTips.find(e => e.name === "VerifyReplaceModule")
    if(verifyToolTip.status){
    
      this.verify_tooltip_description = verifyToolTip.description ? verifyToolTip.description :  null
      this.verfify_tooltip_name = verifyToolTip.name ? verifyToolTip.name :  null
    }
    return },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    formatNumber(cellValue) {
      let val = new Intl.NumberFormat("en-US", {
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 10,
      }).format(cellValue);
      return val;
    },
    formatReceivedQuantity(row, column, cellValue) {
      return Util.numberWithCommas(cellValue);
    },
    formatMoney(row, column, cellValue) {
      return Util.inMoneyFormatWithoutDollarSign(cellValue);
    },
    async handleEdit() {
      if (this.editMode) {
        await this.saveItemQuantities();
      } else {
        this.editMode = true;
      }
    },
    cancelEditMode() {
      this.editMode = false;
      this.getReplacementItems(this.$route.params.id);
    },
    async handleEdit() {
      if (this.editMode) {
        await this.saveItemQuantities();
      } else {
        this.editMode = true;
      }
    },
    markChanged(id) {
      if(this.changedItems.includes(id)) return;

      this.changedItems.push(id);
    },
    async saveItemQuantities() {
      let updateStatus = false;
      // Loop through each of the line items
      // Fetch LineItem for each
      let bases = this.replacementItems.filter(item => this.changedItems.includes(item.lineItemId));
      let items = bases.map(itm => {
        return {
          lineItemId: itm.lineItemId,
          orderId: itm.orderId,
          receivedQuantity: itm.receivedQuantity,
          unitPrice: itm.unitPrice,
          requestedQuantity: itm.requestedQuantity,
          partnerItemTotal: itm.partnerItemTotal,
          usItemTotal: itm.usItemTotal,
          usItemBalance: itm.usItemBalance
        }
      });

      await this.saveReplacementItems(items).then((res) => {
          updateStatus = true;
          this.changedItems = [];

          this.getReplacementItems(this.$route.params.id);
          this.getReplacementItemReceiptStatus(this.$route.params.id);
        });
   
      //this.$toast.success("Line Item(s) Saved");
      this.editMode = false;
    },
    generateTotal(values) {
      if (!values.every((value) => isNaN(value))) {
        return values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
      } else {
        return null;
      }
    },
    summary(param) {
      const { columns, data } = param;
      const sums = [];
      const totalColumns = ["usItemTotal", "usItemBalance"];
      const quantityColumns = [
        "requestedQuantity",
        "receivedQuantity",
        "unitPrice",
        "partnerItemTotal",
      ];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totals";
          return;
        }

        if (quantityColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? Util.inMoneyFormatWithoutDollarSign(total)
            : "0.00";
          if (
            column.property == "requestedQuantity"
          ) {
            sums[index] = total
              ? Util.inMoneyFormatWithoutDollarSign(total)
              : "0.00";
          }
          if (
            column.property == "receivedQuantity"
          ) {
            sums[index] = total
              ? Util.inMoneyFormatWithoutDollarSign(total)
              : "";
          }
          if (column.property == "usItemBalance") {
            sums[index] = total
              ? `$ ${Util.inMoneyFormatWithoutDollarSign(total)}`
              : "$ 0.00";
          }
        } else if (totalColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? `$ ${Util.inMoneyFormatWithoutDollarSign(total)}`
            : "$ 0.00";
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
  },
};
</script>